import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../auth/registered/SEC_00_DB_Payload"; 

/**
 * 🛰️ REGISTER CORPORATE ENTITY
 * Uses GoldenSourceHelper.get to safely resolve casing from UI state
 * and prepareForApi to ensure the payload is cleaned before POST.
 */
export const registerCorporateEntity = async (formData, config) => {
    try {
        const payload = {
            EntityName: GoldenSourceHelper.get(formData, "EntityName"),
            EntityTypeCode: GoldenSourceHelper.get(formData, "EntityTypeCode"), 
            TaxReference: GoldenSourceHelper.get(formData, "TaxReference"),
            ParentEntityId: GoldenSourceHelper.get(formData, "ParentEntityId") || null,
            IsPartOfStructure: true,
            IsActive: true
        };

        const rawData = await dbPayload(
            "/api/v1/corporate/workflow/save-entity", 
            "POST", 
            config.siteKey, 
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Entity registration failed.");
        return res.data; 
    } catch (err) {
        console.error("Corporate Registration Error:", err);
        throw err;
    }
};

/**
 * 🛰️ FETCH REGISTRY (The List)
 */
export const fetchCorporateRegistry = async (config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/corporate/workflow/get-registry", 
            "POST", 
            config.siteKey, 
            {} 
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Registry Sync Failed:", err);
        return [];
    }
};

/**
 * 🛰️ FETCH HIERARCHY (The Tree)
 */
export const fetchCorporateHierarchy = async (corporateEntityId, config) => {
    try {
        // Ensure the ID is wrapped or passed correctly based on API needs
        const payload = { CorporateEntityId: corporateEntityId };

        const rawData = await dbPayload(
            "/api/v1/corporate/workflow/get-tree", 
            "POST", 
            config.siteKey, 
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Hierarchy Fetch Failed:", err);
        return [];
    }
};